export default __webpack_public_path__ + "static/media/fund-3.98c5b326.jpeg";